var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { signOutStart } from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.actions";
import * as authApi from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.api";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Formik } from "formik";
import queryString from "query-string";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import { DisplayText, Fieldset, Form, PasswordField, TextContainer, } from "../../components";
import { Button } from "../../components/Button";
import * as t from "../../services/translationService";
import { StyledAuthBody, StyledAuthContent, StyledAuthFrame, StyledAuthLogo, StyledAuthMain, StyledAuthMedia, StyledAuthMediaWrap, } from "./Auth.styled";
import { InternalModeButton } from "./components/InternalModeButton";
var changePassword = Yup.object().shape({
    newPassword: Yup.string()
        .required(t.formErrorRequired(t.authNewPasswordLabel()))
        .min(8, t.formErrorInvalidPassword()),
});
var ChangePassword = function (props) {
    var _a = props.showLink, showLink = _a === void 0 ? true : _a;
    var navigate = useNavigate();
    // Query params
    var queryParams = queryString.parse(window.location.search);
    // State
    var dispatch = useDispatch();
    var _b = React.useState(false), hasResetPassword = _b[0], setHasResetPassword = _b[1];
    // Event handlers
    var handleFormSubmit = function (params, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var newPassword, token, unknownError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newPassword = params.newPassword;
                    token = queryParams.token;
                    if (!token || !newPassword) {
                        showAlert({ type: "error", message: getLocalizedText("general.error") });
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, authApi.resetPassword(token, newPassword)];
                case 2:
                    _a.sent();
                    setHasResetPassword(true);
                    return [3 /*break*/, 4];
                case 3:
                    unknownError_1 = _a.sent();
                    showAlert({ type: "error", message: getLocalizedText("general.error") });
                    return [3 /*break*/, 4];
                case 4:
                    actions.setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderRequestPasswordResetForm = function (_a) {
        var status = _a.status, isSubmitting = _a.isSubmitting;
        return (
        // @ts-ignore
        _jsxs(Form, { children: [_jsx(Fieldset, { children: _jsx(PasswordField, { name: "newPassword", label: t.authNewPasswordLabel(), autoFocus: true }) }), status && _jsx("div", { children: status }), _jsx(Button, { type: "submit", isDisabled: isSubmitting, appearance: "primary", isFullWidth: true, children: t.authChangePasswordResetSubmitLabel() })] }));
    };
    return (_jsxs(StyledAuthFrame, { children: [_jsx(StyledAuthContent, { children: _jsxs(StyledAuthMain, { children: [_jsx(InternalModeButton, {}), _jsx(StyledAuthLogo, {}), _jsxs(StyledAuthBody, { children: [_jsx(DisplayText, { children: t.authChangePasswordTitle() }), hasResetPassword ? (_jsxs(TextContainer, { children: [_jsx("p", { children: t.authChangePasswordChangesMessage() }), showLink && (_jsx("p", { children: _jsx(Button, { onClick: function () {
                                                    dispatch(signOutStart.getAction());
                                                    navigate("/auth/signin");
                                                }, appearance: "link", children: t.authToLogin() }) }))] })) : (_jsx(Formik, { initialValues: { newPassword: "" }, onSubmit: handleFormSubmit, validationSchema: changePassword, render: renderRequestPasswordResetForm }))] })] }) }), _jsx(StyledAuthMediaWrap, { children: _jsx(StyledAuthMedia, {}) })] }));
};
// eslint-disable-next-line import/no-default-export
export default ChangePassword;
